import { IQuery, Topics } from '@zaplify/common';
import { ProspectDto } from '../prospects';

export class GetProspectsByIdsQuery extends IQuery<ProspectDto[]> {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(readonly prospectIds: string[]) {
        super();
    }
}
